<form [formGroup]="setupForm">
  <div class="setup-intro">
    <p>
      Use this tile to stack content rows with optional images and buttons. Set the shared
      background first, then configure the content for each row.
    </p>
  </div>

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Settings</h2>
    </div>
    <div class="editor-section__content">
      <div class="background-settings">
        <p class="section-intro">Sets the shared background shown behind every text row.</p>
        <mat-form-field appearance="fill">
          <mat-label>Background</mat-label>
          <input matInput formControlName="background" />
          <mat-hint>Defines the background image or asset used for the tile.</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </section>
  <hr class="editor-divider" />

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Text Rows</h2>
    </div>
    <div class="editor-section__content">
      <p class="section-intro">
        Each row can have its own heading, body text, image, and optional buttons.
      </p>
      <div
        *ngFor="let textRow of textRows.controls; let i = index"
        [formGroup]="textRow"
        class="text-rows-container"
      >
        <div class="text-row-form">
          <div class="text-row-form__header">
            <h3>Row {{ i + 1 }}</h3>
            <button type="button" mat-icon-button aria-label="Remove text row" (click)="removeTextRow(i)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>

          <div class="text-style-row">
            <mat-form-field appearance="fill" class="text-style-row__field">
              <mat-label>Heading</mat-label>
              <input matInput formControlName="heading" />
              <mat-hint>Sets the row heading.</mat-hint>
            </mat-form-field>

            <div class="text-style-row__controls">
              <mat-form-field appearance="outline" class="font-size-field">
                <mat-label>Size</mat-label>
                <mat-select formControlName="headingFontSize">
                  <mat-option *ngFor="let sizeOption of fontSizesOptions" [value]="sizeOption">
                    {{ sizeOption }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <lib-color-picker-square
                [formGroup]="textRow"
                controlName="headingFontColor"
                [inputId]="'headingFontColor-' + i"
                ariaLabel="Heading colour"
              ></lib-color-picker-square>
            </div>
          </div>

          <div class="text-style-row">
            <mat-form-field appearance="fill" class="text-style-row__field">
              <mat-label>Text</mat-label>
              <textarea matInput formControlName="text" rows="4"></textarea>
              <mat-hint>Defines the main body copy for the row.</mat-hint>
            </mat-form-field>

            <div class="text-style-row__controls">
              <mat-form-field appearance="outline" class="font-size-field">
                <mat-label>Size</mat-label>
                <mat-select formControlName="textFontSize">
                  <mat-option *ngFor="let sizeOption of fontSizesOptions" [value]="sizeOption">
                    {{ sizeOption }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <lib-color-picker-square
                [formGroup]="textRow"
                controlName="textFontColor"
                [inputId]="'textFontColor-' + i"
                ariaLabel="Text colour"
              ></lib-color-picker-square>
            </div>
          </div>

          <div class="media-row">
            <mat-form-field appearance="fill" class="media-row__field">
              <mat-label>Image</mat-label>
              <input matInput formControlName="img" />
              <mat-hint>Defines the image shown in this row.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="media-row__position">
              <mat-label>Image Position</mat-label>
              <mat-select formControlName="imgPosition">
                <mat-option *ngFor="let position of horizontalPositionOptions" [value]="position.key">
                  {{ position.name }}
                </mat-option>
              </mat-select>
              <mat-hint>Image placement.</mat-hint>
            </mat-form-field>
          </div>

          <mat-card>
            <mat-card-header>
              <mat-card-title>Buttons</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <p class="section-intro">Add optional buttons that should appear in this row.</p>
              <lib-links-editor
                [linksFormArray]="getLinkButtonsControls(i)"
                [tileDefinition]="tileDefinition?.textRows?.[i]"
              ></lib-links-editor>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <button class="add-btn" mat-raised-button color="primary" (click)="addTextRow()">
        Add Text Row
      </button>
    </div>
  </section>
</form>
<div class="footer">
  <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
</div>
